export default "query UserSubscriptions($locale:Locale!){user{subscriptions(locale:$locale){state type{key}}}}"